const en = {
  buttons: {
    more: "Zobacz więcej",
  }
};

export default en;
